import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { NoteService } from '../note/note.service';

@Injectable()
export class TabService {

	constructor(
		private configService: ConfigService,
		private noteService: NoteService
	) { }

	showTab(persona, notPersona) {

		let showTab = false;

		const self = this;

		if (persona === undefined || persona == null || !Array.isArray(persona)) {
			showTab = true;
		}

		if (persona !== undefined && persona !== null && Array.isArray(persona)) {
			persona.forEach(function (d, i) {
				if (d === 'all' || d === self.configService.persona) {
					showTab = true;
				}
			});
		}

		if (notPersona !== undefined && notPersona !== null && Array.isArray(notPersona)) {
			notPersona.forEach(function (d, i) {
				if (d === 'all' || d === self.configService.persona) {
					showTab = false;
				}
			});
		}

		return showTab;
	}

	loadTab(tabs: Array<any>, tabService: any, initTab: string): void {
		const self = this;
		let foundInitTab = false;
		if (initTab !== '') {
			tabs.forEach(function (d, i) {
				console.log('CHECK TAB FOR INIT', d, self.showTab(d.persona, d.notPersona));
				if (!foundInitTab && d.prop === initTab) {
					if (self.showTab(d.persona, d.notPersona)) {
						if (d.listTab) {
							foundInitTab = true;
							console.log('SELECT INIT TAB');
							tabService.tabClick({}, d.prop, tabs, 'standard');
						}
					} else {
						console.log('NO ACCESS TAB');
						self.noteService.displayError('You do not have access to the requested list. Loading default tab.');
						tabService.selectDefaultTab(tabs);
					}
				}
			});
		}

		if (!foundInitTab) {
			console.log('SELECT DEFAULT TAB');
			tabService.selectDefaultTab(tabs);
		}
	}
}
